'use strict'

const FETCH_ALLOWED_FEATURES_REQUEST = "FETCH_ALLOWED_FEATURES_REQUEST";
const FETCH_ALLOWED_FEATURES_SUCCESS = "FETCH_ALLOWED_FEATURES_SUCCESS";
const FETCH_ALLOWED_FEATURES_FAILURE = "FETCH_ALLOWED_FEATURES_FAILURE";

export {
    FETCH_ALLOWED_FEATURES_REQUEST,
    FETCH_ALLOWED_FEATURES_SUCCESS,
    FETCH_ALLOWED_FEATURES_FAILURE
}